export default {
  pageTitle: 'Heat Exchanger Fabrication',
  metaDescription: 'TEF fabricates shell & tube heat exchangers, reboilers, condensers and coolers in copper-nickel, titanium, and duplex stainless steel for demanding process industries.',
  sidebar: {
    title: 'Fabrication list',
    vessel: 'Fabrication Vessel',
    heatExchanger: 'Fabrication Heat Exchanger',
    piping: 'Fabrication Piping',
    tower: 'Fabrication Tower',
    muffle: 'Fabrication Muffle',
    radiantTube: 'Fabrication Radiant Tube',
    otherEquipment: 'Fabrication Other Equipment',
  },
  fabricationOf: 'Fabrication of',
  product: {
    name: 'Heat Exchanger',
    desc: 'The following is a catalog of our experience in Heat Exchanger fabrication in various types of materials, types and specifications.',
  },
};
